import { Editor, useEditorState } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLabel } from '../../../IconLabel';

import classNames from 'classnames';
import classes from '../InlineTools.module.scss';
import './Link.module.scss';

interface LinkProps {
  editor: Editor;
  onClick: () => void;
}

export const Link: FunctionComponent<LinkProps> = ({ editor, onClick }) => {
  const { t } = useTranslation();

  const { isActive, isActiveCode } = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isActive: editor.isActive('link'),
      isActiveCode: editor.isActive('code'),
    }),
  });

  return (
    <IconLabel
      iconId={'link'}
      iconSize={16}
      ariaLabel={t('richTextEditor.tool-names-link')}
      onClick={onClick}
      disabled={isActiveCode}
      className={classNames(classes['inline-tools__item'], {
        [classes['inline-tools__item--active']]: isActive,
        [classes['inline-tools__item--disabled']]: isActiveCode,
      })}
    />
  );
};
